module.exports = __webpack_public_path__ + "static/img/ex05.8ac6c543.png";